import { Fragment, useState, useEffect } from 'react';
// import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Container, IconButton, Tooltip } from '@mui/material';
import Alert from '@mui/material/Alert';
import PersonIcon from '@mui/icons-material/Person';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';

// project imports
import HeaderOutlet from 'layout/MainLayout/Header';
import FooterOutlet from 'layout/MainLayout/Footer';
import useAuth from 'hooks/useAuth';
import { hasDbAccess } from 'utils/User';

// assets
import { PATH_ACCOUNT } from 'routes/paths'

const Body = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    // minWidth: '25rem',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.primary.light
}));

const Header = styled('div')(({ theme }) => ({
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    backgroundColor: theme.palette.background.default,
    borderBottom: '1px solid',
    borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.grey[200],
    color: theme.palette.text.dark
}));

const Footer = styled('div')(({ theme }) => ({
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto'
}));

const MainContainer = styled(Container)(({ theme }) => ({
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    minHeight: 0,
    padding: '0 20px 0 20px',
    display: 'flex',
    flexDirection: 'column'
}));

const MainLayout = () => {
    const theme = useTheme();
    const { user, isLoggedIn } = useAuth();
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));

    const [openInfo, setOpenInfo] = useState(() => {
        const saved = localStorage.getItem("openInfo260111");
        return saved !== null ? JSON.parse(saved) : true;
    });

    useEffect(() => {
        localStorage.setItem("openInfo260111", JSON.stringify(openInfo));
    }, [openInfo]);

    return (
        <Body>
            {  !isLoggedIn || hasDbAccess(user)
                ? <Fragment />
                :
                    <Alert severity="warning" sx={{borderRadius: 0}}>
                        {user.dbu
                            ? `Platnost Vaší licence vypršela ${new Date(user.dbu * 1000).toLocaleDateString('cs-CZ')}`
                            : 'Pro používání aplikace je nutná platná licence' }

                            <Tooltip title={user.dbu ? 'Prodlužte si licenci o 1 rok v nastavení účtu' : 'Zakupte si licenci o 1 rok v nastavení účtu'}>
                                <span>
                                    <IconButton
                                        aria-label={
                                            user.dbu
                                                ? 'Prodlužte si licenci o 1 rok v nastavení účtu'
                                                : 'Zakupte si licenci o 1 rok v nastavení účtu'
                                        }
                                        sx={{color: 'inherit'}}
                                        component={RouterLink}
                                        to={PATH_ACCOUNT.root}
                                    >
                                        <PersonIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                    </Alert>

            }
            <Header>
                <HeaderOutlet />
            </Header>

            <MainContainer disableGutters={mdDown}>
                <Collapse in={openInfo}>
                    <Alert
                        variant="outlined"
                        severity="info"
                        action={
                            <IconButton
                            aria-label="close"
                            color="inherit"

                            size="small"
                            onClick={() => {
                                setOpenInfo(false);
                            }}
                            >
                            <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{
                            mt: 3,
                            backgroundColor:
                                theme.palette.mode === 'light'
                                    ? '#fff'
                                    : 'transparent',
                            userSelect: 'none'
                        }}
                    >
                        Od 5. ledna docházelo ke snížení systémového výkonu a prodlevám v odezvách. Na základě provedené analýzy jsme optimalizovali mechanismus generování odpovědí a nasadili novou verzi aplikace, která výrazně zkracuje dobu zpracování požadavků a výrazně zvyšuje rychlost systému nad minulou úroveň pro plynulé odborné využití. V případě jakéhokoliv problému s aplikací napište e-mail na hlaseni@drugagency.cz
                    </Alert>
                </Collapse>
                <Outlet />
            </MainContainer>

            <Footer>
                <Container disableGutters={mdDown} sx={{padding: '0 20px 0 20px'}}>
                    <FooterOutlet />
                </Container>
            </Footer>
        </Body>
    );
};

export default MainLayout;
